<div class="card-container" [ngClass]="ngClass">
  <ng-content></ng-content>
</div>
